export const FEATURE_URL = '/get-feature-description';
export const TIP_URL = '/tip/get';
